import { Http } from '../axios/interceptors'

export const allPromotionsByCompany = async (param) => Http('GET', `/Promotions/GetByCompany?`, param)

export const getPromotion = async id => Http('GET', `/Promotions/Get?idPromotion=${id}`)

export const createOrEditPromotions = async (body, id = null) => (id ? Http('PUT', `/Promotions/Update`, null, body) : Http('POST', '/Promotions/Create',null,body))

export const deletePromotion = async id => Http('DELETE', `/Promotions/Delete?idPromotion=${id}&active=false`)
